import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import {
    Row,
    Col,
} from 'reactstrap';
import ListContactsNotes2 from './ListContactsNotes2';
import EditContactsNote2 from './EditContactsNote2';
import AddContactsNote2 from './AddContactsNote2';
import './Notes2.css';
import CompanyContext from '../../auth/CompanyContext';

const ContactsNotesForm2 = (props) => {
    const {
        editID,
        clientToken,
        user,
        displayCategories,
        addCategorySubCommentsArray,
        setNotesCount
    } = props;

    const companyCtx = useContext(CompanyContext);

    const [contactsNotes, setContactsNotes] = useState([]);
    const [editNoteID, setEditNoteID] = useState(0);

    const getContactsNotes = useCallback(() => {
        // keep existing behavior
        if (displayCategories) displayCategories({ target: { value: 27 } });

        if (!editID) {
            setContactsNotes([]);
            setEditNoteID(0);
            return;
        }

        fetch(`/api/contactsNotes/${editID}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + clientToken,
                'X-Database': companyCtx.company
            }
        })
            .then((r) => r.json())
            .then((results) => {
                setContactsNotes(results?.data || []);
            });
    }, [displayCategories, editID, clientToken, companyCtx.company]);

    useEffect(() => {
        getContactsNotes();
    }, [getContactsNotes]);

    const addNote = useCallback((date, typeID, notes, cb) => {
        if (!editID) return;

        fetch('/api/contactsNotes/', {
            method: 'POST',
            body: JSON.stringify({
                contactGUID: editID,
                date,
                typeID,
                notes,
                user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + clientToken,
                'X-Database': companyCtx.company
            }
        })
            .then((r) => r.json())
            .then(() => {
                if (cb) cb();
                getContactsNotes();
            });
    }, [editID, user, clientToken, companyCtx.company, getContactsNotes]);

    const editNote = useCallback((contactGUID, date, typeID, notes, cb) => {
        fetch(`/api/contactsNotes/${contactGUID}`, {
            method: 'PUT',
            body: JSON.stringify({
                date,
                typeID,
                notes,
                user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + clientToken,
                'X-Database': companyCtx.company
            }
        })
            .then((r) => r.json())
            .then(() => {
                if (cb) cb();
                getContactsNotes();
                setEditNoteID(0);
            });
    }, [user, clientToken, companyCtx.company, getContactsNotes]);

    const deleteNote = useCallback((contactGUID, cb) => {
        fetch(`/api/contactsNotes/${contactGUID}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + clientToken,
                'X-Database': companyCtx.company
            }
        })
            .then((r) => r.json())
            .then(() => {
                if (cb) cb();
                getContactsNotes();
                setEditNoteID(0);
            });
    }, [clientToken, companyCtx.company, getContactsNotes]);

    const handleEditSwap = useCallback((id) => {
        setEditNoteID(id);
    }, []);

    useEffect(() => {
        if (setNotesCount) setNotesCount(contactsNotes.length);
    }, [contactsNotes.length, setNotesCount]);

    const activityList = useMemo(() => {
        const listRow = (addCategorySubCommentsArray?.filter(item => item.longDescription !== 'Other') || []).find(r => r.validation === 'list');
        return listRow?.list || [];
    }, [addCategorySubCommentsArray]);

    return (
        <Row>
            <Col md={6}>
                {contactsNotes.map((row) => (
                    <div key={row.id} className="mb-2">
                        <hr className="border-dark" />

                        {editNoteID !== row.id ? (
                            <ListContactsNotes2
                                row={row}
                                handleEditSwap={handleEditSwap}
                            />
                        ) : (
                            <EditContactsNote2
                                row={row}
                                activityList={activityList}
                                handleEditSwap={handleEditSwap}
                                editNote={editNote}
                                deleteNote={deleteNote}
                            />
                        )}
                    </div>
                ))}
            </Col>
            <Col>
                <AddContactsNote2
                    addNote={addNote}
                    addCategorySubCommentsArray={addCategorySubCommentsArray}
                    activityList={activityList}
                />
            </Col>
        </Row>
    );
};

export default ContactsNotesForm2;